import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {HelixThemeSection as HelixThemeSectionType} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function HelixThemeSection({section, children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
          helix_yn: 'y',
        },
        viewimp_contents: {
          imp_provider: 'helix',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  const {title, subtitle, description, scheme} = section as Omit<
    HelixThemeSectionType,
    'groups'
  >;

  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {
          layer1: '헬릭스테마',
          imp_id: 'shelix',
          imp_provider: 'helix',
        },
        viewimp_contents: {
          imp_id: 'shelix',
          imp_provider: 'helix',
          imp_type: 'vimp',
          layer1: '헬릭스테마',
        },
        customProps: {
          section_type: '헬릭스테마',
          helix_yn: 'y',
        },
      })}
    >
      <div className="flex flex-col justify-around pt-20pxr pb-8px">
        {title && (
          <TitleBar
            type={TitleBarType.Helix}
            title={title}
            {...(!subtitle && {
              scheme,
              description,
            })}
          />
        )}
        {subtitle && (
          <TitleBar
            type={TitleBarType.Helix}
            title={subtitle}
            description={description}
            scheme={scheme}
          />
        )}
      </div>
      <div>{children}</div>
    </div>
  );
}
